import { createSlice } from "@reduxjs/toolkit";

const shepDialogSlice = createSlice({
  name: "shepDialog",
  initialState: {
    alert: {
      open: false,
      title: "Alert",
      message: "",
      buttonLabel: "OK",
      variant: "info",
    },
    confirm: {
      open: false,
      title: "Confirm",
      message: "",
      confirmLabel: "Confirm",
      cancelLabel: "Cancel",
      variant: "info",
      confirmVariant: "primary",
    },
    prompt: {
      open: false,
      title: "Input Required",
      message: "",
      defaultValue: "",
      placeholder: "",
      submitLabel: "Submit",
      cancelLabel: "Cancel",
      required: false,
      multiline: false,
      rows: 1,
      type: "text",
      min: undefined,
      max: undefined,
    },
  },
  reducers: {
    showAlert: (state, action) => {
      const { message, ...options } = action.payload;
      state.alert = {
        open: true,
        message,
        title: options.title ?? "Alert",
        buttonLabel: options.buttonLabel ?? "OK",
        variant: options.variant ?? "info",
      };
    },
    closeAlert: (state) => {
      state.alert.open = false;
    },
    showConfirm: (state, action) => {
      const { message, ...options } = action.payload;
      state.confirm = {
        open: true,
        message,
        title: options.title ?? "Confirm",
        confirmLabel: options.confirmLabel ?? "Confirm",
        cancelLabel: options.cancelLabel ?? "Cancel",
        variant: options.variant ?? "info",
        confirmVariant: options.confirmVariant ?? "primary",
      };
    },
    closeConfirm: (state) => {
      state.confirm.open = false;
    },
    showPrompt: (state, action) => {
      const { message, ...options } = action.payload;
      state.prompt = {
        open: true,
        message,
        title: options.title ?? "Input Required",
        defaultValue: options.defaultValue ?? "",
        placeholder: options.placeholder ?? "",
        submitLabel: options.submitLabel ?? "Submit",
        cancelLabel: options.cancelLabel ?? "Cancel",
        required: options.required ?? false,
        multiline: options.multiline ?? false,
        rows: options.rows ?? 1,
        type: options.type ?? "text",
        min: options.min,
        max: options.max,
      };
    },
    closePrompt: (state) => {
      state.prompt.open = false;
    },
  },
});

export const {
  showAlert,
  closeAlert,
  showConfirm,
  closeConfirm,
  showPrompt,
  closePrompt,
} = shepDialogSlice.actions;

export const selectAlertDialog = (state) => state.tempInfo.shepDialog.alert;
export const selectConfirmDialog = (state) => state.tempInfo.shepDialog.confirm;
export const selectPromptDialog = (state) => state.tempInfo.shepDialog.prompt;

export default shepDialogSlice.reducer;
